import { Form, Input } from "antd";
import React from "react";
import { validatePassword } from "../utils/passwordValidation";

import { useTranslation } from "react-i18next";
const PasswordField = ({ autoComplete = "new-password" }) => {
  const { t } = useTranslation("dashboard");
  return (
    <Form.Item
      label={t("Password")}
      name="password"
      hasFeedback
      rules={[
        {
          validator: validatePassword
        }
      ]}
      extra={
        <div style={{ fontSize: "12px", color: "var(--ds-text-2)", marginTop: "4px" }}>
          {t("Password must contain:")}
          <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
            <li>{t("At least 8 characters")}</li>
            <li>{t("One uppercase letter")}</li>
            <li>{t("One lowercase letter")}</li>
            <li>{t("One number")}</li>
            <li>{t("One special character")}</li>
          </ul>
        </div>
      }
    >
      <Input.Password autoComplete={autoComplete} />
    </Form.Item>
  );
};

export default PasswordField;
